export const numberOfApplicationsList = [
  { name: "1 vez", value: 1 },
  { name: "2 vezes", value: 2 },
  { name: "3 vezes", value: 3 },
  { name: "4 vezes", value: 4 },
  { name: "5 vezes", value: 5 },
  { name: "6 vezes", value: 6 },
];

export const findNumberOfApplicationByValue = (value) => {
  return numberOfApplicationsList.find((entry) => entry.value === value);
};
